import { Component, ElementRef, HostListener, OnInit, TemplateRef, ViewChild, ViewContainerRef } from '@angular/core';
import {Router } from '@angular/router';
import { AuthService } from './core/auth/auth.service';
import { ApiService } from './core/services/api.service';
import { LanguageService } from './core/services/language.service';
import { UtilService } from './core/services/util.service';
import * as moment from "moment";
import * as CryptoJS from "crypto-js";
import { environment } from 'environments/environment';
import { HttpParams } from '@angular/common/http';
import { FuseSplashScreenService } from '@fuse/services/splash-screen';
import { MatDialog } from '@angular/material/dialog'
import { TitleService } from './core/services/title.service';

@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
    favIcon: HTMLLinkElement = document.querySelector("#appIcon");
    language: any = localStorage.getItem("language");
    profileData: any;
    @ViewChild("confirmModal") confirmModal!: TemplateRef<ElementRef>;
    ischecked: boolean = false;
    isContinue: boolean;
    imagePathSrc: string;
    /**
     *  Constructor
     */
    constructor(
        private api: ApiService,
        private util: UtilService,
        private router: Router,
        private authFackservice: AuthService,
        private lan: LanguageService,
        public viewContainerRef: ViewContainerRef,
        private fuseSpashScreen: FuseSplashScreenService,
        private _matDialog: MatDialog,
        private titleService:TitleService,
    ) {
        console.log = function () { };
        console.warn = function () { };
        console.table = function () { };
        let checkLang;
        if (localStorage.getItem("language")) {
            checkLang = localStorage.getItem("language");
            if (checkLang == undefined) {
                localStorage.setItem("language", "en");
                window.location.reload();
            }
            if (checkLang == null) {
                localStorage.setItem("language", "en");
                window.location.reload();
            }
        }
        if (this.language) {
            moment.locale(this.language);
            this.lan.setLanguage(this.language);
        } else {
            this.language = "en";
            moment.locale(this.language);
            this.lan.setLanguage(this.language);
        }

        if (localStorage.getItem("prevCred")) {
            let credential = JSON.parse(localStorage.getItem("prevCred"))
            let password = CryptoJS.AES.encrypt(credential.password, '0WlRFbfa3k');
            let email = CryptoJS.AES.encrypt(credential.email, '0WlRFbfa3k');
            credential.password = password.toString()
            credential.email = email.toString()
            console.log("credential", credential)
            let CgVjURfZ: any = {}
            CgVjURfZ.pk1IRHm5 = email.toString()
            CgVjURfZ.g4z5ckyX = password.toString()
            localStorage.setItem('CgVjURfZ', JSON.stringify(CgVjURfZ))
            localStorage.removeItem("prevCred")
        }

        this.profileData = JSON.parse(localStorage.getItem("currentUser"));
        document.documentElement.style.setProperty(
            "--warmup-window-width",
            window.innerWidth.toString() + "px"
        );

        this.api.refreshData.onmessage = (messageEvent) => {
            if (messageEvent.data == 'settings') {
                this.getSettingsData('new')
            } else if (messageEvent.data == 'logout') {
                this.router.navigate(['/sign-out']);
            } else if (messageEvent.data == 'login') {
                if (window['returnUrl']) {
                    this.router.navigateByUrl(window['retrunUrl'])
                    window.location.reload()
                } else {
                    this.router.navigateByUrl("/")
                    window.location.reload()
                }
            }
        }
        
        this.imagePathSrc = '/assets/images/logo/';
    }



    ngOnInit(): void {
        const paramsMatch = window.location.href.match(/\?.+/);
        if (paramsMatch) {
            console.log('paramsMatch', paramsMatch)
            console.log('paramsMatch', paramsMatch[0])
            const params = new URLSearchParams(paramsMatch[0]);
            const authToken = params.get("token");
            const errorMessage = params.get('errorMessage')
            const param = new HttpParams();
            if (errorMessage) this.util.showToast(errorMessage, true)
            if (authToken) {
                this.authFackservice.currentUserSetValue({ token: authToken });
                localStorage.setItem("token", authToken);
                const user = {
                    token: authToken,
                }
                localStorage.setItem('currentUser', JSON.stringify(user));
                this.api.userToken = authToken;
                console.log('authToken', authToken)
                this.router.navigateByUrl("/");
            }
        }

        if (localStorage.getItem('currentUser')) {
            this.getSettingsData();
            this.getCurrentPlan();
            this.getProfileData();
        } else {
            this.favIcon.href = this.imagePathSrc + 'favicon.png'
        }

        this.onResize();
    }

    @HostListener("window:resize", ["$event"])
    onResize(event?) {
        document.documentElement.style.setProperty(
            "--warmup-window-width",
            window.innerWidth.toString() + "px"
        );
    }

    /**
      * * Get Settings Data
    */
    getSettingsData(type?) {
        this.api.getData('settings').subscribe({
            next: (res: any) => {
                if (res.success) {
                    this.api.settingsData = res.data;
                    this.api.isLoadSettings.next(true);
                    let userData
                    if (localStorage.getItem("currentUser")) {
                        userData = JSON.parse(localStorage.getItem("currentUser"))
                    }
                    if (res.language && (!userData || !userData.id)) {
                        this.language = res.language
                        localStorage.setItem("language", res.language)
                        this.lan.setLanguage(res.language)
                    }

                    console.log('favIcon', this.favIcon)
                    if (this.favIcon && res.data.favicon) {
                        console.log('check condition')
                        this.favIcon.href = res.data.imagePath + res.data.favicon;
                    }
                    setTimeout(() => {
                        this.fuseSpashScreen.hide()
                        document.body.classList.remove('fuse-splash-screen-hidden');
                        document.body.classList.add('removeLoader');
                    }, 500);
                } else {
                }
            },
            error: (err) => {
                console.log('err', err);
                if (err == "Server Error") {
                    if(environment.domainType == 'com') {
                        window.location.href = "https://warmify.partnereach.com/";
                    } 
                    return;
                }
                if (err == "deactivated") {
                    if(environment.domainType == 'com') {
                        window.location.href = "https://warmify.partnereach.com/";
                    }
                    return;
                }
            }
        })
    }

    getProfileData() {
        this.api.getData('profile').subscribe({
            next: (res: any) => {
                if (res.success) {
                    if(res.data && res.data.is_accept_warmup_policy == 0) {
                        const dialogRef = this._matDialog.open(
                            this.confirmModal,
                            {
                                autoFocus: false,
                                width: '580px',
                                maxWidth: '580px',
                                panelClass: 'custom_modal',
                                disableClose: true,
                            }
                        );

                        dialogRef.afterClosed().subscribe({
                            next: (res: any) => {
                                
                            },
                        });
                    }
                    res.data.token = localStorage.getItem('token')
                    localStorage.setItem('currentUser', JSON.stringify(res.data));
                    this.authFackservice.currentUserSetValue(res.data);
                    if (this.language != res.data.language) {
                        localStorage.setItem("language", res.data.language);
                        this.lan.setLanguage(res.data.language);
                    }
                } else {

                }
            },
            error: (err) => {
                console.log('err', err);
            },
            complete() {

            },
        })
    }

    getCurrentPlan() {
        this.api.getData('current-plan').subscribe({
            next: (res: any) => {
                if (res.success) {
                    this.api.activatedPlan = res.data;
                    this.api.currentPlanLoaded.next(true);
                } else {

                }
            },
            error: (err) => {
                console.log('err', err);
            }
        })
    }

    acceptPolicy() {
        if(!this.ischecked || this.isContinue) return;
        this.isContinue = true;
        this.api.getData('accept-policy').subscribe({
            next: (res:any) => {
                if(res.success) {
                    this.isContinue = false;
                    this.util.showToast(res.message);
                    this._matDialog.closeAll();
                } else {
                    this.isContinue = false;
                    this.util.showToast(res.message, true);
                }
            },
            error: (err) => {
                console.log('err', err);
                this.isContinue = false;
            },
            complete() {
                
            },
        })
    }

}



